import React, { useId } from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const IconGlowGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  const id = useId();

  return (
    <g fill="none" {...(props.group ?? {})} filter={`url(#${id}_filter)`}>
      <ellipse
        cx="75.5"
        cy="18.5"
        rx="60.5"
        ry="3.5"
        fill={fillColor}
        style={{ mixBlendMode: 'multiply' }}
      />

      <defs>
        <filter
          id={`${id}_filter`}
          x="0"
          y="0"
          width="151"
          height="37"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result={`${id}_flood`} />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2={`${id}_flood`}
            result="shape"
          />
          <feGaussianBlur stdDeviation="7.5" />
        </filter>
      </defs>
    </g>
  );
};

export const IconGlowSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="151"
      height="37"
      viewBox="0 0 151 37"
      {...(props.svg ?? {})}
    >
      <IconGlowGroup {...props} />
    </svg>
  );
};
